import React, { useEffect, useState } from "react";
import PostDate from "../Article/Posts/Posts.json";
import { Helmet } from "react-helmet";
import { motion, AnimatePresence,useAnimation } from "framer-motion";
import ScrollToTop from "./ScrollToTop";


export default function Article(props) {
    const [value, setValue] = useState("");
    const animation = useAnimation()

    let id = props.id;
    console.log(id);

    useEffect(() => {
        console.log("uE")
        ImportArticle(id,setValue)
        animation.start({opacity: 1})
    },[id]);

    
    return (
        <>

            <Helmet>
                <title>
                    {PostDate[id].Title} | {`${props.siteName}`}
                </title>
            </Helmet>   
            {value}
            {console.log(value)}
        </>
    );
}

function ImportArticle(id,setValue) {
    
    return (
        (async () => {
            const { default: ArticleDate } = await import(
                `../Article/Posts/Day${id}`
            );
            console.log("go");
            return(
                <>
                                <ScrollToTop />      
                    {setValue(ArticleDate)}
                </>);
            // eslint-disable-next-line
        })(),
        (<></>)
    );
}
